import { render, staticRenderFns } from "./videoResource.vue?vue&type=template&id=9421c48c&scoped=true&"
import script from "./videoResource.vue?vue&type=script&lang=js&"
export * from "./videoResource.vue?vue&type=script&lang=js&"
import style0 from "./videoResource.vue?vue&type=style&index=0&id=9421c48c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9421c48c",
  null
  
)

export default component.exports